<template>
    <div :class="classes">
        <div @click="isOpen = !isOpen" :class="theme.header">
            <v-row align-items="center">
                <v-col>
                    <slot name="title"></slot>
                </v-col>
                <v-col :class="theme.action">
                    <slot name="caption"></slot>
                    <v-icon-button grey :class="theme.button">
                        expand_more
                    </v-icon-button>
                </v-col>
            </v-row>
        </div>
        <v-animation-height :height="height">
            <slot></slot>
        </v-animation-height>
    </div>
</template>

<script>
    import { vAnimationHeight } from '../AnimationHeight';
    import { vIconButton } from '../Button';
    import { vCol,vRow } from '../Grid';
    import theme from './expansion.scss';

    export default {
        name: 'expansion',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        components: {
            vCol,
            vRow,
            vIconButton,
            vAnimationHeight,
        },
        data() {
            return {
                isOpen: false,
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.expansion]: true,
                    [this.theme.isOpen]: this.isOpen,
                }
            },
            buttonClasses() {
                return {
                    [this.theme.isOpen]: this.isOpen,
                };
            },
            height() {
                return this.isOpen ? 'auto' : 0;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Expansion.vue?4ebafb1e